import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';
import { useUpdateTotalNotification } from '../../utils/useUpdateTotalNotification';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';
import { IncidentArchiveAcknowledgeCommand } from '../../api/models';

interface AcknowledgeModalTypes {
	getIncidentReportsDetailsDataArchive: () => Promise<void>;
	closeModal?: closeModalType;
	incidentId?: string;
	title?: string;
}

const AcknowledgeModal: React.FC<AcknowledgeModalTypes> = ({
	getIncidentReportsDetailsDataArchive,
	closeModal,
	incidentId,
	title
}) => {
	// Error and loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');
	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const acknowledgeYourselfArchive = async () => {
		setIsLoading(true);

		const data: IncidentArchiveAcknowledgeCommand = { incidentId: incidentId };

		const response = await apibridge.acknowledgeYourselfArchive(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			getIncidentReportsDetailsDataArchive();

			useUpdateTotalNotification();
		}
	};
	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to acknowledge <strong> '{title}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={acknowledgeYourselfArchive}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default AcknowledgeModal;
